import { render, staticRenderFns } from "./DeviceSectionView.vue?vue&type=template&id=475955f2&scoped=true&"
import script from "./DeviceSectionView.vue?vue&type=script&lang=js&"
export * from "./DeviceSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475955f2",
  null
  
)

export default component.exports